<app-sub-page class="width-100" navBackRoute="/about">
  <div class="flex width-100 column flex-1 scrollable gap-05" style="max-width: 800px" [style.height]="getContainerHeight()">
    <div class="text-title width-100 flex">Versions</div>
    <p-accordion value="0">
      @for (version of versions; track $index; let last = $last) {
      <p-accordionTab>
        <ng-template pTemplate="header">
          <div class="flex width-100 flex-between" style="margin-right: 1rem">
            <div class="flex align-center flex-between" style="width: 90px">
              <div>{{ version.version }}</div>
              @if (version.beta) {
              <p-tag severity="success" value="Beta" />
              }
            </div>
            @if (version.isNew) {
            <p-tag severity="warning" value="New!" />
            }
          </div>
        </ng-template>
        <div class="flex column width-100 gap-1">
          <div class="flex width-100" style="gap: 2rem">
            <div style="font-weight: 600; color: var(--text-title)">Release Date:</div>
            <div style="font-weight: 600">{{ version.releaseDate }}</div>
          </div>
          <div class="flex column width-100">
            <div style="font-weight: 600; color: var(--text-title)">Description:</div>
            <div style="font-size: 0.9rem; color: var(--text-color-secondary)">{{ version.description }}</div>
          </div>
          <div class="flex column width-100">
            <div style="font-weight: 600; color: var(--text-title)">Features:</div>
            <ul style="padding: 0 auto; margin: 0 auto; width: 100%;">
              @for (feature of version.features; track $index) {
              <li style="padding: 0.5rem 0; color: var(--text-color-secondary); font-size: 0.9rem">{{ feature }}</li>
              }
            </ul>
          </div>
          <div class="flex column width-100">
            <div style="font-weight: 600; color: var(--text-title)">Fixes:</div>
            <ul style="padding: 0 auto; margin: 0 auto; width: 100%;">
              @for (fix of version.fixes; track $index) {
              <li style="padding: 0.5rem 0; color: var(--text-color-secondary); font-size: 0.9rem">{{ fix }}</li>
              }
            </ul>
          </div>
        </div>
      </p-accordionTab>
      @if (!last) {
      <div style="border-bottom: 1px solid var(--surface-300)"></div>
      } }
    </p-accordion>
  </div>
</app-sub-page>
